module.exports = __webpack_public_path__ + "static/media/truck4.c92cedc2.jpg";